var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileScreen)?_c('ylNewsHomeMobile',_vm._b({},'ylNewsHomeMobile',_vm.$attrs,false)):_c('ylNewsHomePC',_vm._b({},'ylNewsHomePC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }